import { memo, useCallback } from 'react';
import { LuMapPin } from 'react-icons/lu';
import { SidebarSection, SectionTitle, SectionContent, FormGroup } from './FlightPlannerStyles';

/**
 * Shared Project Information section used by both Orthomosaic and DSP config panels.
 * Renders project name (required), auto-detected municipality, and description.
 */
const ProjectInfoSection = ({
	projectSettings,
	onSettingsChange,
	detectedMunicipality,
	namePlaceholder = 'My Flight Project',
}) => {
	const updateField = useCallback(
		(field, value) => onSettingsChange(prev => ({ ...prev, [field]: value })),
		[onSettingsChange]
	);

	return (
		<SidebarSection>
			<SectionTitle>Project Information</SectionTitle>
			<SectionContent>
				<FormGroup>
					<label>
						Project Name: <span style={{ color: '#ff6b6b' }}>*</span>
					</label>
					<input
						type="text"
						value={projectSettings.name}
						onChange={e => updateField('name', e.target.value)}
						placeholder={namePlaceholder}
						style={{
							borderColor: !projectSettings.name ? '#ff6b6b40' : undefined,
						}}
					/>
				</FormGroup>

				{detectedMunicipality && (
					<FormGroup>
						<label>Municipality:</label>
						<div style={{ fontSize: '0.85rem', color: '#4CAF50', padding: '0.3rem 0' }}>
							<LuMapPin
								size={14}
								style={{ verticalAlign: 'middle', marginRight: '4px' }}
							/>
							{detectedMunicipality.name}
						</div>
					</FormGroup>
				)}

				<FormGroup>
					<label>Description:</label>
					<textarea
						value={projectSettings.description}
						onChange={e => updateField('description', e.target.value)}
						placeholder="Optional project description..."
						rows={2}
						style={{ resize: 'vertical' }}
					/>
				</FormGroup>
			</SectionContent>
		</SidebarSection>
	);
};

export default memo(ProjectInfoSection);
